import {motion, useTransform} from "framer-motion";
import {useEasedValue} from "./useEasedValue";

interface Props {
	/** The value to show; every change is travelled to rather than jumped to. */
	value: number;
	/** Renders the travelling value — locale-aware formatting belongs to the caller. */
	format: (value: number) => string;
	/** Travel time, defaulting to {@link EASED_VALUE_SECONDS}. */
	durationSeconds?: number;
}

/**
 * A formatted number that eases between values (ui#942).
 *
 * **It is `aria-hidden`, so the value MUST be exposed to assistive tech elsewhere** — on this card,
 * by the `progressbar` that each of these annotates (`aria-valuenow` / `aria-valuetext`). While the
 * number travels its text node is rewritten every frame, and inside the progress card's polite live
 * region that would be an announcement storm rather than information.
 */
export function AnimatedNumber({value, format, durationSeconds}: Props) {
	const eased = useEasedValue(value, durationSeconds);
	const text = useTransform(eased, format);

	return <motion.span aria-hidden="true">{text}</motion.span>;
}
